import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFastForward: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconFastForward"><Path d="M6.88832 5.34412L12.2424 9.92938V6.6733C12.2424 5.17854 13.9954 4.37182 15.1307 5.34412L21.351 10.6711C22.1665 11.3696 22.1665 12.631 21.351 13.3295L15.1307 18.6565C13.9954 19.6288 12.2424 18.8221 12.2424 17.3273V14.0712L6.88832 18.6565C5.75299 19.6288 4 18.8221 4 17.3273V6.6733C4 5.17854 5.75299 4.37182 6.88832 5.34412Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFastForward;
